if(!customElements.get('bundle-products')){
    class BundleProducts extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.section = this.closest('.section-bundle-products');
            this.popupBundleProducts = this.section?.querySelector('.bundle-products-popup');
            this.productListInputType = this.dataset.productListInputType || 'primary';

            this.hotspots = this.querySelectorAll(".bundle-products__hotspot");
            this.hotspots.forEach(item => {
                const hotspotIcon = item.querySelector('.hotspot-icon');
                hotspotIcon?.addEventListener("click", this.openProductCta.bind(this));
                hotspotIcon?.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.openProductCta(e);
                    }
                });

                // close button
                const hotspotCta = item.querySelector(".hotspot-cta");
                if(hotspotCta){
                    const buttonClose = hotspotCta.querySelector('.button-close');
                    buttonClose?.addEventListener("click", this.closeProductPopupByButton.bind(this));
                    buttonClose?.addEventListener("keydown", e => {
                        if(e.key === 'Enter'){
                            this.closeProductPopupByButton(e);
                        }
                    });
                }

                // close popup when clicking outside
                document.addEventListener("click", e => {
                    if(!hotspotCta.contains(e.target) && !hotspotIcon.contains(e.target)){
                        this.closeProductPopup(hotspotCta);
                    }
                });

                document.addEventListener("focus", (e) => {
                    if(!hotspotCta.contains(e.target) && !hotspotIcon.contains(e.target)){
                        this.closeProductPopup(hotspotCta);
                    }
                }, true);
            });

            this.productLists = this.querySelectorAll('.bundle-products__product-list');

            // submit the cart
            this.buttonCart = this.section?.querySelector('.button-cart');
            this.cartDrawer = document.querySelector('cart-drawer');
            this.addedToCartPopup = document.querySelector('added-to-cart-popup');

            if(this.buttonCart){
                this.buttonCart.addEventListener("click", this.submitProductFormsToCart.bind(this));
            }

            this.onVariantChangeUnsubscriber = PubSub.subscribe(PubSub.events.optionValueSelectionChangeInBundleProduct, this.handleOptionValueChange.bind(this));

            // variant accordion
            this.variantAccordions = this.querySelectorAll('.product-variant-item');
            this.variantAccordions.forEach(accordion => {
                this.toggleVariantAccordion(accordion);

                if(this.productListInputType !== 'primary'){
                    accordion.querySelectorAll('.label--primary').forEach(item => {
                        item.classList.remove('label--primary');
                        item.classList.add(`label--${this.productListInputType}`);
                    });
                    accordion.querySelectorAll('.select--primary').forEach(item => {
                        item.classList.remove('select--primary');
                        item.classList.add(`select--${this.productListInputType}`);
                    });
                }
            });

            // product JSON data
            if(this.querySelector('.bundle-products__products-data')){
                this.productData = JSON.parse(this.querySelector('.bundle-products__products-data').innerHTML);
            }
        }

        disconnectedCallback(){
            if(this.onVariantChangeUnsubscriber){
                this.onVariantChangeUnsubscriber();
            }   
        }

        toggleVariantAccordion(accordion){
            const variantWrapper = accordion.closest('.variant');
            const buttonVariant = variantWrapper?.querySelector('.button-variant');

            buttonVariant?.addEventListener("click", () => {
                this.openVariantAccordion(accordion);
            });

            buttonVariant?.addEventListener("keydown", (e) => {
                if(e.key === 'Enter'){
                    this.openVariantAccordion(accordion);
                }
            });
        }

        openVariantAccordion(accordion){
            const isOpen = accordion.getAttribute('data-open') === 'true'? true : false;
            const parent = accordion.closest('.variant');
            const buttonVariant = parent?.querySelector('.button-variant');
            if(isOpen){
                accordion.setAttribute('data-open', 'false');
                accordion.setAttribute('inert', '');
                accordion.style.height = '0px';
                accordion.style.overflow = 'hidden';
                if(buttonVariant) buttonVariant.setAttribute('aria-expanded', 'false');
            }else{
                const height = accordion.querySelector('.product-variant-item__inner').offsetHeight;
                accordion.style.height = `${height}px`;
                accordion.style.overflow = 'hidden';
                accordion.setAttribute('data-open', 'true');
                accordion.removeAttribute('inert');
                if(buttonVariant) buttonVariant.setAttribute('aria-expanded', 'true');
                
                setTimeout(() => {
                    accordion.style.overflow = 'visible';
                }, 300);

                const productItem = accordion.closest('.product-list__product-info');
                const productList = accordion.closest('.product-list');
                if(productItem && productList){
                    productList.scrollTo({
                        top: productItem.offsetTop - productList.offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        }

        openProductCta(e){
            if(!e.currentTarget) return;

            const hotspotIcon = e.currentTarget;
            const parent = hotspotIcon.closest('.bundle-products__hotspot');
            const productPopup = parent?.querySelector(".hotspot-cta");

            const width = window.innerWidth;

            if(productPopup){
                if(width < 991){ // mobile
                    this.openPopup(productPopup);
                    return;
                }

                //tab index
                productPopup.querySelectorAll('[tabindex]').forEach(item => {
                    item.setAttribute('tabindex', '0');
                });
                if(productPopup.getAttribute('data-hidden') === 'false'){
                    parent.style.zIndex = '20';
                    productPopup.setAttribute('data-hidden', 'true');
                    productPopup.setAttribute('inert', '');
                }else{
                    parent.style.zIndex = '21';
                    productPopup.setAttribute('data-hidden', 'false');
                    productPopup.removeAttribute('inert');
                }
            }
        }

        openPopup(popup){
            if(!this.popupBundleProducts) return;

            this.popupBundleProducts.querySelector('.popup__content').innerHTML = popup.innerHTML;
            this.popupBundleProducts.setAttribute('data-hidden', 'false');
            this.popupBundleProducts.removeAttribute('inert');
            this.popupBundleProducts.querySelectorAll('[tabindex]').forEach(item => {
                item.setAttribute('tabindex', '1');
            });

            const buttonClose = this.popupBundleProducts.querySelector('.button-close');
            buttonClose.addEventListener("click", this.closePopup.bind(this));
            buttonClose.addEventListener("keydown", e => {
                if(e.key === 'Enter' || e.key === ' '){
                    e.preventDefault();
                    this.closePopup();
                }
            });

            this.popupBundleProducts.addEventListener("click", (e) => {
                if(this.popupBundleProducts === e.target){
                    this.closePopup();
                }
            });

            this.popupBundleProducts.addEventListener("keyup", (e) => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            FocusTrap.activate(this.popupBundleProducts);
        }

        closePopup(){
            if(!this.popupBundleProducts) return;

            FocusTrap.deactivate(this.popupBundleProducts);

            this.popupBundleProducts.setAttribute('data-hidden', 'true');
            this.popupBundleProducts.setAttribute('inert', '');

            const buttonClose = this.popupBundleProducts.querySelector('.button-close');
            buttonClose.removeEventListener("click", this.closePopup.bind(this));

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            setTimeout(() => {
                this.popupBundleProducts.querySelector('.popup__content').innerHTML = '';
            }, 300);
        }

        closeProductPopupByButton(e){
            if(!e.currentTarget) return;

            const parent = e.currentTarget.closest(".bundle-products__hotspot");
            const productPopup = parent?.querySelector(".hotspot-cta");

            this.closeProductPopup(productPopup);
        }

        closeProductPopup(popup){
            if(popup){
                const parent = popup.closest('.bundle-products__hotspot');

                parent.style.zIndex = '20';
                //tab index
                popup.querySelectorAll('[tabindex]').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                });
                popup.setAttribute('data-hidden', 'true');
                popup.setAttribute('inert', '');
            }
        }

        submitProductFormsToCart(){
            const forms = this.section?.querySelectorAll('.shopify-product-form');
            forms.forEach(form => {
                this.onSubmitToCart(form);
            });
        }

        async onSubmitToCart(form){
            const productItem = form.closest('.product-list__product-info');
            if(!productItem) return;

            // handle error message
            this.handleErrorMessage(form);

            this.buttonCart.classList.add('disabled');
            this.buttonCart.classList.add('loading');
            productItem.querySelector('.badge--sold-out')?.remove();

            const formData = new FormData(form);

            // config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;
            
            await fetch(`${routes.cart_add_url}`, config)
            .then(res => res.json())
            .then(res => {
                if(res.status) {
                    PubSub.publish(PubSub.events.cartError, {
                        source: 'product-card',
                        productVariantId: formData.get('id'),
                        errors: res.errors || res.description,
                        message: res.message
                    });

                    this.handleErrorMessage(form, res.description);

                    // sold out
                    if(this.buttonCart){
                        this.buttonCart.classList.remove('loading');
                        this.buttonCart.classList.remove('inner-group');
                    }

                    const soldoutBadge = document.createElement('span');
                    soldoutBadge.innerHTML = window.cart.badge.sold_out;
                    soldoutBadge.classList.add('badge', 'badge--sold-out', 'my-3', 'max-w-max');

                    if(productItem){
                        productItem.querySelectorAll(".badge").forEach(item => item.remove());
                        productItem.querySelector(".price")?.append(soldoutBadge);
                        productItem.querySelector('.price')?.classList.add('price--sold-out');
                        productItem.querySelector('.price')?.classList.remove('price--on-sale');
                        productItem.querySelector('.price')?.classList.remove('price--no-compare');
                        productItem.querySelector('.price')?.classList.remove('volumn-pricing--sale-badge');
                    }

                    this.error = true;
                    return;
                }

                if(!this.cartDrawer){ // if cart drawer is disabled
                    window.location = window.routes.cart_url;
                    return;
                }
                
                this.error = false;

                if(this.addedToCartPopup){
                    this.addedToCartPopup.renderContent(res);
                }else{ // if added to cart popup is disabled
                    this.updateCartSize();
                }
            }).catch(e => {
                console.error(e);
            }).finally(() => {
                this.buttonCart.classList.remove('disabled');
                this.buttonCart.classList.remove('loading');
            });
        }

        handleErrorMessage(form, message = ""){
            const errorWrapper = form.querySelector(".error");
            if(!errorWrapper) return;

            errorWrapper.querySelector('small').innerText = `${message}`;
        }

        updateCartSize(){
            const cartIconURL = `/?section_id=header-cart-icon`;
            fetch(cartIconURL)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
                return res.text();
            }).then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                const header = document.querySelector('custom-header');
                const cartSizeIcons = header?.querySelectorAll('.cart-item-size');
                if(cartSizeIcons.length > 0){
                    cartSizeIcons.forEach(item => {
                        item.innerText = resultsMarkup.trim();
                        item.setAttribute('aria-hidden', 'false');
                    });
                }
            }).catch(e => {
                console.error(e);
            });
        }

        handleOptionValueChange({ data: { event, target, selectedOptionValues, productId }}){
            if (!this.contains(event.target)) return;

            const productUrl = target.dataset.productUrl || this.pendingRequestUrl;
            const targetProductId = target.dataset.optionValueId;

            this.pendingRequestUrl = productUrl;

            this.renderProductInfo({
                requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
                targetId: targetProductId,
                productId: productId,
                callback: this.updateProductInfo(productUrl, productId)
            });
        }

        updateProductInfo(productUrl, productId){
            return (html) => {
                this.getProductInfo(html, productId);
            }
        }

        getProductInfo(html, productId){
            const productInfo = html.querySelector('.product-list__product-info');
            if(!productInfo) return;

            const productField = this.querySelector('.product-list__product-info[data-product-id="' + productId + '"]');
            if(!productField) return;

            productField.innerHTML = productInfo.innerHTML;
            
            // re-initialize variant selector
            if(productField.querySelectorAll('variant-selector').length > 0){
                productField.querySelectorAll('variant-selector').forEach(variantSelector => {
                    const variantWrapper = variantSelector.closest('.product-variant-item');
                    const scripts = variantWrapper.querySelectorAll('script');
                    const newScripts = [];
                    scripts.forEach(script => {
                        if(script.getAttribute('type') !== 'application.json'){
                            newScripts.push(script);
                            script.remove();
                        }
                    });

                    newScripts.forEach(script => {
                        const newScript = document.createElement('script');
                        if(script.src) {
                            newScript.src = script.src;
                        }else{
                            newScript.textContent = script.textContent;
                        }

                        Array.from(script.attributes).forEach(attr => {
                            newScript.setAttribute(attr.name, attr.value);
                        });

                        variantWrapper.append(newScript);
                    });

                    // update the variant selector input type
                    if(this.productListInputType !== 'primary'){
                        variantSelector.querySelectorAll('.label--primary').forEach(item => {
                            item.classList.remove('label--primary');
                            item.classList.add(`label--${this.productListInputType}`);
                        });
                        variantSelector.querySelectorAll('.select--primary').forEach(item => {
                            item.classList.remove('select--primary');
                            item.classList.add(`select--${this.productListInputType}`);
                        });
                    }
                });
            }

            // re-initialize accordion
            if(productField.querySelector('.product-variant-item')){
                this.toggleVariantAccordion(productField.querySelector('.product-variant-item'));
            }

            // update price
            const newPriceData = productField.querySelector('.product-json-data');
            if(newPriceData){
                const priceData = JSON.parse(newPriceData.innerHTML);
                this.updateTotalPrice(priceData);
            }
        }

        renderProductInfo({ requestUrl, targetId, productId, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

            this.pendingRequestUrl = requestUrl;

            const productField = this.querySelector('.product-list__product-info[data-product-id="' + productId + '"]');
            const variantWrapper = productField?.querySelector('.variant');
            variantWrapper?.setAttribute('data-loading', 'true');

            fetch(`${requestUrl}`, { signal: this.abortController.signal })
            .then((res) => res.text())
            .then((resText) => {
                this.pendingRequestUrl = null;
                const html = new DOMParser().parseFromString(resText, 'text/html');
                callback(html);
            })
            .catch((error) => {
                if(error.name === 'AbortError') {
                    console.log('Fetch aborted by user');
                }else{
                    console.error(error);
                }
            }).finally(() => {
                variantWrapper?.setAttribute('data-loading', 'false');
            });
        }

        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false){
            const params = [];

            !shouldFetchFullPage && params.push(`section_id=bundle-product-item`);

            if(optionValues.length) {
                params.push(`option_values=${optionValues.join(',')}`);
            }

            return `${url}?${params.join('&')}`;
        }

        updateTotalPrice(priceData){
            if(!priceData) return;
            if(!this.productData) return;

            const productId = priceData.productId;
            const availability = priceData.available;
            const price = priceData.price;

            const productsData = this.productData.products;
            if(productsData && productsData.length > 0){
                for(const item of productsData){
                     if(item.id === productId){
                        item.available = availability;
                        item.price = price;
                    }
                }
            }

            // update total price display
            let totalPrice = 0;
            this.productData.products.forEach(item => {
                if(item.available){
                    totalPrice += item.price;
                }
            });

            if(this.productData.total_price !== totalPrice){
                this.productData.total_price = totalPrice;
            }

            // update json data
            const productsDataScript = this.section?.querySelector('.bundle-products__products-data');
            if(productsDataScript){
                productsDataScript.innerHTML = JSON.stringify({
                    products: this.productData.products,
                    total_price: this.productData.total_price,
                    saving_percentage: this.productData.saving_percentage
                });
            }

            // subtotal price element
            const subtotalPriceEl = this.querySelector('.item-total-price--subtotal .value');
            if(subtotalPriceEl){
                const currencyCode = subtotalPriceEl.getAttribute('data-with-currency') === 'true';
                subtotalPriceEl.innerText = Shopify.formatMoney(totalPrice, currencyCode? window.moneyFormatWithCurrency : window.moneyFormat);
            }

            // bundle & saving element
            const bundleSavingEl = this.querySelector('.item-total-price--save .value');
            if(bundleSavingEl){
                const savingPercentage = this.productData.saving_percentage || 0;
                const savingAmount = Math.round((totalPrice * savingPercentage) / 100);
                const currencyCode = bundleSavingEl.getAttribute('data-with-currency') === 'true';
                bundleSavingEl.innerText = Shopify.formatMoney(savingAmount, currencyCode? window.moneyFormatWithCurrency : window.moneyFormat);
            }

            // total price element
            const totalPriceEl = this.querySelector('.item-total-price--total .value');
            if(totalPriceEl){
                const savingPercentage = this.productData.saving_percentage || 0;
                const savingAmount = Math.round((totalPrice * savingPercentage) / 100);
                const finalTotalPrice = totalPrice - savingAmount;
                const currencyCode = totalPriceEl.getAttribute('data-with-currency') === 'true';
                totalPriceEl.innerText = Shopify.formatMoney(finalTotalPrice, currencyCode? window.moneyFormatWithCurrency : window.moneyFormat);
            }
        }
    }

    customElements.define('bundle-products', BundleProducts);
}